import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Ensure this file exists and contains necessary styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import RoleProvider from './context/RoleContext'; // Import RoleProvider if it exists
import './style.css'; // Ensure this file exists and contains necessary styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RoleProvider> {/* Wrap with RoleProvider if applicable */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </RoleProvider>
    </AuthProvider>
  </React.StrictMode>
);


reportWebVitals();